// src/app/auth/msal.config.ts
import {
  IPublicClientApplication, PublicClientApplication, LogLevel, InteractionType
} from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration, MsalGuardConfiguration
} from '@azure/msal-angular';
import { environment } from '../../environments/environment';

/** INSTANCE: multi-tenant via organizations */
export function makeMsalInstance(env = environment): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: env.msal.clientId,
      authority: env.msal.authority || 'https://login.microsoftonline.com/organizations',
      redirectUri: env.msal.redirectUri ?? env.redirectUri,
      postLogoutRedirectUri: env.msal.postLogoutRedirectUri ?? env.loginUrl
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        loggerCallback: (level, message) => {
          if (env.debugAuth) console.debug('[MSAL]', level, message);
        }
      }
    }
  });
}

/** GUARD: pedir SOMENTE OIDC (nada de Graph ou .default aqui) */
export function makeMsalGuardConfig(_env = environment): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['openid', 'profile', 'offline_access'],
      prompt: 'select_account'
    }
  };
}

/**
 * INTERCEPTOR:
 *  - NÃO mapear sua API (devapi.lojinhalibbs.com.br), nem a rota de troca
 *  - Se precisar Graph, mapeie só o Graph
 */
export function makeMsalInterceptorConfig(_env = environment): MsalInterceptorConfiguration {
  const map = new Map<string, Array<string>>([
    // Remova se não usa Graph:
    ['https://graph.microsoft.com/v1.0', ['User.Read']],
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: map
  };
}
